import { Exclude, plainToInstance } from 'class-transformer'
import { Guid } from 'guid-typescript'

import { ActionTypes } from '../types'

export class RemoveProperties {
  type = ActionTypes.RemoveProperties

  identifiers!: Array<number>

  @Exclude()
  guid: string = Guid.create().toString()

  getNewModel() {
    return plainToInstance(RemoveProperties, {
      type: ActionTypes.RemoveProperties,
      identifiers: []
    })
  }

}
